import { NewFileInput } from "../gql/graphql"
import imageCompression from "browser-image-compression"
import config from "../config/config"

export const uploadFiles = async ({
  files,
  getPrecent,
  cbErr,
}: {
  files: File[]
  getPrecent?: (value: number) => void
  cbErr: (err: any) => void
}) => {
  try {
    let images: NewFileInput[] = []

    const uploadPromises = files.map(async (file) => {
      if (!file || file.size > 100 * 1024 * 1024) {
        return Promise.resolve()
      }

      // Compress the file if it's an image
      let fileToUpload = file
      if (file.type.includes("image")) {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        }
        fileToUpload = await imageCompression(file, options)
      }

      const formData = new FormData()
      formData.append("files", fileToUpload, file.name)

      return new Promise<void>((resolve, reject) => {
        const xhr = new XMLHttpRequest()

        const baseUrl = config.isOnDev
          ? "http://localhost:3000"
          : config.REST_URL  // adapte selon ta config

        xhr.open("POST", `${baseUrl}/upload`)

        // Suivi de la progression
        xhr.upload.onprogress = (event) => {
          if (event.lengthComputable) {
            const progress = (event.loaded / event.total) * 100
            getPrecent && getPrecent(progress)
          }
        }

        xhr.onload = () => {
          if (xhr.status >= 200 && xhr.status < 300) {
            try {
              const response: Array<{
                name: string
                url: string
                type: string
                size: number
              }> = JSON.parse(xhr.responseText)

              response.forEach((uploadedFile) => {
                images.push({
                  name: uploadedFile.name,
                  type: uploadedFile.type,
                  size: uploadedFile.size,
                  url: uploadedFile.url,
                })
              })
              resolve()
            } catch (e) {
              reject(new Error("Erreur parsing réponse serveur"))
            }
          } else {
            reject(new Error(`Erreur upload: ${xhr.status} ${xhr.statusText}`))
          }
        }

        xhr.onerror = () => reject(new Error("Erreur réseau lors de l'upload"))
        xhr.ontimeout = () => reject(new Error("Timeout lors de l'upload"))

        xhr.send(formData)
      })
    })

    await Promise.all(uploadPromises)
    return images
  } catch (error) {
    cbErr(error)
  }
}